var _path, _path2, _rect, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 49,
    viewBox: "0 0 59 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.617 8.31934H2.17446L25.3372 24.6751L32.617 19.6644V8.31934Z",
    fill: "url(#paint0_linear_927_2783)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3372 27.795L0 10.3047V48.4996L5.8616 42.9217H50.9581V25.9987H39.7076C36.3797 25.9987 34.2872 23.5406 33.6569 22.3115L25.3372 27.795Z",
    fill: "url(#paint1_linear_927_2783)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 34.4131,
    width: 24.3918,
    height: 24.3918,
    rx: 5.48343,
    fill: "#F43735"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M44.1444 16.1679C43.4879 16.1653 42.9229 16.0037 42.4496 15.6831C41.9788 15.3624 41.6162 14.898 41.3617 14.2898C41.1098 13.6816 40.9851 12.95 40.9876 12.095C40.9876 11.2425 41.1136 10.5159 41.3655 9.91535C41.62 9.31479 41.9826 8.858 42.4534 8.54499C42.9267 8.22944 43.4904 8.07167 44.1444 8.07167C44.7984 8.07167 45.3608 8.22944 45.8316 8.54499C46.3049 8.86055 46.6688 9.3186 46.9233 9.91917C47.1778 10.5172 47.3037 11.2425 47.3012 12.095C47.3012 12.9525 47.174 13.6854 46.9195 14.2936C46.6676 14.9018 46.3062 15.3663 45.8354 15.6869C45.3646 16.0075 44.801 16.1679 44.1444 16.1679ZM44.1444 14.7975C44.5923 14.7975 44.9498 14.5723 45.217 14.1219C45.4842 13.6714 45.6166 12.9958 45.614 12.095C45.614 11.502 45.5529 11.0083 45.4308 10.6139C45.3112 10.2195 45.1407 9.92299 44.9193 9.7245C44.7004 9.526 44.4422 9.42676 44.1444 9.42676C43.6991 9.42676 43.3428 9.64943 43.0756 10.0948C42.8084 10.5401 42.6735 11.2068 42.671 12.095C42.671 12.6955 42.7308 13.1968 42.8504 13.5989C42.9725 13.9984 43.1443 14.2987 43.3657 14.4998C43.5871 14.6983 43.8467 14.7975 44.1444 14.7975ZM51.8808 8.17855V15.9961H50.228V9.7474H50.1822L48.392 10.8696V9.40385L50.3273 8.17855H51.8808Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_927_2783",
    x1: 0.174805,
    y1: 2.49976,
    x2: 32.1748,
    y2: 47.9998,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4AA0EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5858E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_927_2783",
    x1: 0.174805,
    y1: 2.49976,
    x2: 32.1748,
    y2: 47.9998,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4AA0EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5858E0"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.46befceac746ce45c64d408491ba5144.svg";
export { ForwardRef as ReactComponent };